<div class="profile-wrapper" [formGroup]="form">

  <!-- AGENT VIEW -->
  <ng-container *ngIf="isAgent; else defaultView">

    <div class="profile-header agent-header">
      <div>
        <h6>Profile Settings</h6>
        <p>View your account information</p>
      </div>
      <button class="close-btn" type="button" (click)="activeModal.dismiss()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="loading-area" *ngIf="isLoading">
      <app-loading [isLoading]="isLoading"></app-loading>
    </div>

    <!-- AGENT VIEW -->
    <div class="profile-form scrollable-form two-col" *ngIf="!isLoading">

      <div class="form-group">
        <label>Agent Name</label>
        <input type="text" class="form-control" formControlName="fullName" readonly />
      </div>
      <div class="form-group">
        <label>Agency Name</label>
        <input type="text" class="form-control" formControlName="agencyName" readonly />
      </div>


      <div class="form-group">
        <label>Agent Email Address</label>
        <input type="email" class="form-control" formControlName="email" readonly />
      </div>

      <div class="form-group">
        <label>Agency NPN</label>
        <input type="text" class="form-control" formControlName="agencyNpn" readonly />
      </div>


      <div class="form-group">
        <label>Role</label>
        <input type="text" class="form-control" formControlName="role" readonly />
      </div>
      <div class="form-group">
        <label>Principal Name</label>
        <input type="text" class="form-control" formControlName="principalName" readonly />
      </div>

    </div>

  </ng-container>

  <!-- UW_ASSIST / UNDERWRITER VIEW -->
  <ng-template #defaultView>

    <div class="profile-header">
      <h6>Profile Settings</h6>
      <p>View your account information</p>
    </div>

    <div class="profile-form">

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" placeholder="Enter email" />
      </div>

      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="fullName" placeholder="Enter full name" />
      </div>

      <div class="form-group">
        <label>Role</label>
        <input type="text" class="form-control" formControlName="role" placeholder="Enter role" />
      </div>

    </div>

    <div class="actions">
      <button class="outline btn-md" type="button" (click)="activeModal.dismiss()">
        Cancel
      </button>

      <button class="primary btn-md" type="button" [disabled]="form.invalid" (click)="save()">
        Save Changes
      </button>
    </div>

  </ng-template>

</div>